var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowpackage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.306,
    height: 86.073,
    viewBox: "0 0 62.306 86.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M2667.4,191.125s-5.928,1.94-6,9.308,0,40.746,0,40.746-.849,16.4,30.9,28.868c0,0,30.965-11.49,31.361-28.868V200.433s.689-6.951-6.2-9.308c-.207.207-21.1-6.412-21.1-6.412a12.155,12.155,0,0,0-8.48,0C2687.877,185.127,2667.4,191.125,2667.4,191.125Z",
    transform: "translate(-2661.372 -183.973)",
    fill: "#16b1ef"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowpackage1);
export default __webpack_public_path__ + "static/media/flowpackage1.94fb383d046748c2b4bc31ab43d6ecf3.svg";
export { ForwardRef as ReactComponent };